import React from "react";
import {Accordion, AccordionDetails, AccordionSummary, Box, Container, Tab, Tabs, Typography} from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";

export default function PastRemarks(props) {
  return (
    <>
    <Box
      sx = {{p: 2, pt: 0}}
    >
      <Tabs
        indicatorColor = "primary"
        value = {1}
      >
        <Tab
          label = "特記事項"
          sx = {{minWidth: 0}}
          value = {1}
        />
      </Tabs>
    </Box>
    <Container
      maxWidth = "sm"
      sx = {{p: 2, flexGrow: 1}}
    >
      {props.data.map((data, i) => (
        <Accordion
          defaultExpanded = {!Boolean(parseInt(props.custom)) && i === 0}
          disabled = {Boolean(parseInt(props.custom))}
          key = {"remarks_" + i}
          sx = {{m: "2px!important", boxShadow: "none"}}
        >
          <AccordionSummary
            className = "btn-select"
            sx = {{height: 45, minHeight: "0!important"}}
          >
            <Typography>
              {data[0]}
            </Typography>
            {Boolean(parseInt(props.custom)) &&
              <LockIcon
                fontSize = "small"
                sx = {{pl: 1}}
              />
            }
            {Boolean(parseInt(data[6])) &&
              <Typography
                color = "error"
                sx = {{ml: "auto"}}
              >
                重要
              </Typography>
            }
          </AccordionSummary>
          <AccordionDetails
            sx = {{p: 0}}
          >
            <Container
              maxWidth = "sm"
              sx = {{p: 2, flexGrow: 1}}
            >
              {!Boolean(parseInt(props.custom)) &&
                <Typography>
                  {data[7] || "--"}
                </Typography>
              }
            </Container>
          </AccordionDetails>
        </Accordion>
      ))}
    </Container>
    </>
  );
};
